module.exports = __webpack_public_path__ + "static/media/Hospitality_61.890c357f.jpg";